import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿En qué formato recibiré los materiales?',
  a: 'Todo el contenido es 100% digital en formato PDF de alta calidad. Recibirás el acceso por correo electrónico inmediatamente después de tu compra. Las plantillas editables del Nivel 2 y 3 vienen en formato Word compatible.'
}, {
  q: '¿Necesito conocimientos previos de management para aprovechar este pack?',
  a: 'No. El contenido está diseñado para ser accesible desde cero y progresivo. El Tomo 1 empieza por los fundamentos y los niveles siguientes van añadiendo complejidad de forma gradual.'
}, {
  q: '¿Puedo usar este contenido con mi equipo?',
  a: 'Sí. La licencia incluye uso personal y empresarial. Podés compartir los documentos generados con tu equipo. Lo que no está permitido es la reventa o distribución del material original.'
}, {
  q: '¿El contenido aplica a cualquier tipo de empresa?',
  a: 'El sistema está diseñado para PyMEs y empresas medianas de cualquier sector. Los principios de gestión organizacional son universales. Las plantillas son lo suficientemente genéricas para adaptarse a empresas de servicios, comercio, manufactura y más.'
}, {
  q: '¿Qué pasa si tengo dudas después de la compra?',
  a: 'Podés escribirnos al correo de soporte que recibirás junto con tu compra. Respondemos dentro de las 48 horas hábiles.'
}, {
  q: '¿Por qué debería elegir el Nivel 3 si ya tengo el Nivel 1?',
  a: 'El Nivel 1 te da el conocimiento. El Nivel 2 te da las herramientas para implementarlo. El Nivel 3 te da el sistema para controlar que todo funcione. Los tres juntos forman el ciclo completo: Saber → Hacer → Controlar. Sin el Nivel 3, tenés una empresa que funciona pero no sabés con certeza si está yendo en la dirección correcta.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" aria-labelledby="faq-heading" data-id="element-14">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-15">
        <h2 id="faq-heading" className="text-3xl md:text-4xl font-extrabold text-white text-center mb-12" data-id="element-16">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" role="list" data-id="element-17">
          {faqs.map((faq, index) => <div key={index} className="bg-slate-900 border border-slate-800 rounded-lg overflow-hidden" role="listitem" data-id="element-18">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900 rounded-lg" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-19">
                <span className="font-bold text-white text-lg pr-8" data-id="element-20">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-amber-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-21" />
              </button>
              <AnimatePresence data-id="element-22">
                {openIndex === index && <motion.div id={`faq-answer-${index}`} role="region" aria-labelledby={`faq-question-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-23">
                    <div className="px-6 pb-5 text-slate-300 leading-relaxed border-t border-slate-800 pt-4" data-id="element-24">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </motion.div>
    </section>;
}